SnsProxy = xClass("SnsProxy");
var _proxy = null
SnsProxy.getInstance = function () {
    if (_proxy) {
        return _proxy
    }

    if (window.mini) {
        let platform = mini.getPlatform()
        switch(platform) {
            case MiniPlatform.wechatGame:
                console.log("[####]wechat platform")
                return _proxy = require("clover/sns/snsWechatgame").create()
            case MiniPlatform.qqlightGame:
                console.log("[####]qq platform")
                return _proxy = require("clover/sns/snsQQlightgame").create()
            case MiniPlatform.oppoQuickgame:
                console.log("[####]oppo platform")
                return _proxy = require("clover/sns/snsOppoQuickgame").create()  
            case MiniPlatform.honorQuickgame:
                console.log("[####]honor platform")
                return _proxy = require("clover/sns/snsHonorQuickgame").create()  
            case MiniPlatform.baidu:
                console.log("[####]baidu platform")
                return _proxy = require("clover/sns/snsBaiduGame").create()
            case MiniPlatform.vivo:
                console.log("[####]vivo platform")
                return _proxy = require("clover/sns/snsVivoQuickgame").create()
            case MiniPlatform.tt:
                console.log("[####]tt platform")
                return _proxy = require("clover/sns/snsTTlightgame").create()
            case MiniPlatform.mi:
                console.log("[####]mi platform")
                return _proxy = require("clover/sns/snsMiQuickgame").create()
            case MiniPlatform.ks:
                console.log("[####]ks platform")
                return _proxy = require("clover/sns/snsKsMinigame").create()
            default:
                throw new Error(`Unrecognized platform: ${platform}`);
        }
    } else if (window.META.user.platform == XcloverPlatform.qq||
        window.META.user.platform == XcloverPlatform.weixin) {
        return _proxy = require("clover/sns/snsWanba").create()
    } else if (window.META.user.platform == XcloverPlatform.huawei) {
        return  _proxy =  require("clover/sns/snsHuaweiQuickgame").create()
    } else if (window.META.user.platform == 'he') {
        return  _proxy = SnsProxy.create()
    } else {
        return _proxy = SnsProxy.create()
    }
}

SnsProxy.prototype.getInfo = function (callback) {
    var data = {};
    data.ua = navigator.userAgent;
    callback(data);
}

SnsProxy.prototype.getNetworkType = function (callback) {
    callback(-1);
}

SnsProxy.prototype.addShortcut = function (onSuccess, onFail) {
    onFail('该平台不支持创建快捷方式');
}

SnsProxy.prototype.share = function (textId, platform, type, _imgUrl, _title, _desc, _link, callback) {
    callback({
        retCode: 2,
        data: {
            retCode: 2,
            msg: "分享未发送！"
        }
    });
}

SnsProxy.prototype.openUrl = function (defaultTab, host, target, needParams, onSuccess, onFailed, onCancel) {
    var profile = UserManager.getInstance().getProfileRef();
    var ffUrl = '';
    if (needParams) {
        var data = {}
        if (defaultTab === 1) {
            data.first = 'ask';
        }
        data.app = 6001;
        data.roleid = profile.uid;
        data.uid = profile.uid;
        data.roleavatar = profile.headUrl;
        data.name = profile.name;
        var arr = [];
        for (var name in data) {
            var value = data[name]
            // 手工过滤 #
            if (!value && value !== "#") {
                continue
            }
            arr.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
        }
        var search = arr.join("&");
        ffUrl = `${host}?${search}`;
    } else {
        ffUrl = host;
    }
    location.href = ffUrl;
}

SnsProxy.prototype.refresh = function () {
    window.location.reload()
}

SnsProxy.prototype.sendGameBarMsg = function (frd, msgtype, content, onSuccess, onFail, onCancel) {
    onFail('暂不支持该平台');
}

SnsProxy.prototype.sendGift2Stranger = function (msgtype, content, src) {
    cc.log("sns: 该平台不能给陌生人发送消息");
}

SnsProxy.prototype.getWanbaGiftRewards = function (giftId, onSuccess, onFail, onCancel) {
    onFail('该平台不支持礼包领取');
    // var params = {
    //     giftId: giftId,
    //     qua: META.user.qua,
    //     openid: META.user.openid,
    //     openkey: META.user.openkey,
    //     pf: META.user.pf
    // }

    // var http = GetWanbaGiftRewardsHttp.new(true)

    // function onFinish(event) {
    //     if (onSuccess) {
    //         onSuccess(event.data)
    //     }
    // }

    // function onError(event) {
    //     if (onFail) {
    //         onFail(event)
    //     }
    // }

    // function onCancelled() {
    //     if (onCancel) {
    //         onCancel()
    //     }
    // }

    // http.addEventListener(Events.kComplete, onFinish)
    // http.addEventListener(Events.kError, onError)
    // http.addEventListener(Events.kCancel, onCancelled)
    // http.load(params)
}

SnsProxy.prototype.isQQIOS = function () {
    return false;
}

SnsProxy.prototype.reportLogin = function () {
    cc.log("sns: report login");
}

SnsProxy.prototype.hideKeyboard = function () {
    cc.log("sns: hide keyboard");
}

SnsProxy.prototype.getShareLink = function (srcapp) {
    var suffix = "";
    if (location.search)
        suffix = '&inviteCode=' + UserManager.getInstance().getUserRef().uid;
    else
        suffix = '?inviteCode=' + UserManager.getInstance().getUserRef().uid;
    if (srcapp) {
        suffix += '&srcapp=' + srcapp;
    }
    return location.href + suffix;
}

SnsProxy.prototype.getShareLinkStr = function (data) {
    data['inviteCode'] = UserManager.getInstance().getUserRef().uid;
    var arr = [];
    for (var name in data) {
        var value = data[name]
        // 手工过滤 #
        if (!value && value !== "#") {
            continue
        }
        arr.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
    }
    var suffix = arr.join("&");
    var connector = (location.search) ? "&" : "?";
    return location.href + connector + suffix;
},

    SnsProxy.prototype.banSwipeBack = function () {
        cc.log("sns: banSwipeBack is not supported");
    }

SnsProxy.prototype.showDialog = function (params, okCallback, cancelCallback) {
    require("clover/panel/AlertDialog").create(params, okCallback, cancelCallback).popup()
}

SnsProxy.prototype.alert = function (content, onClickOk) {
    let dialog = require("clover/panel/AlertDialog")
    if (dialog.isReady()) {
        dialog.create({
            text: content,
            needOkBtn: true,
            okBtnText: "重试",
        }, onClickOk)
    } else {
        alert(content)
        onClickOk()
    }
}

SnsProxy.prototype.popBack = function () {
    //不做任何操作
}
SnsProxy.prototype.getOpenKey = function (callback) {
    var data = {};
    callback(data);
}

SnsProxy.prototype.updateNameHeadAfterLogin = function () {
    return
}

/**
 * 获取用户所在城市
 */
SnsProxy.prototype.getUserCity = function(onComplete) {
    onComplete("");
}

SnsProxy.prototype.getDebugInfo = function () {
    return ""
}

SnsProxy.prototype.isQQIOS = function () {
    return false;
}

SnsProxy.prototype.getNetworkType = function (callback) {
    callback(null);
}

SnsProxy.prototype.onLoadingCompleteInitAd = function (callback) {
    cc.log("当前平台不支持广告")
}

SnsProxy.prototype.init = function (data, cb) {
    // console.log("Please implement init function if necessary.");
}

SnsProxy.prototype.initSdk = function (callback) {
    // console.log("Please implement init function if necessary.");
    callback()
}

SnsProxy.prototype.setLoginInterval = function () {
    // console.log("Only wanba need.");
}

SnsProxy.prototype.onLoadingComplete = function () {
    cc.log("sns: loading complete")
}

SnsProxy.prototype.onLoginFinish = function () {
    cc.log("sns: on login finish")
}

/**
 * 广告是否拉取完毕可以播放
 */
SnsProxy.prototype.isAdReady = function(adPos) {
    return false
    throw new Error('Please implements the method! [isAdReady]', 'or return false in allowAds')
}
/**
 * 预加载广告
 */
SnsProxy.prototype.prepareAd = function(adPos) {   
    if (__DEV) {
        return Promise.resolve();
    }     
    throw new Error('Please implements the method! [prepareAd]', 'or return false in allowAds')
}
/**
 * 格子广告用记录看广告
 * @param config
 */
SnsProxy.prototype.finishSaveByGridAd = function() {        
    console.warn('Please implements the method! [finishSaveByGridAd]')
}
/**
 * 显示广告
 * 没有加载广告时会自动加载广告
 * @param Promise
 * resovle: (isEnd)
 */
SnsProxy.prototype.showAd = function (adPos = 0, useDefaultId = false, checkNum = -1, startShowCb,params) {
    if (__DEV) {
        if (startShowCb) {
            startShowCb();
        }
        return new Promise((resolve, reject) => {
            UserManager.getInstance().isTodayFirstShowAd().then((first)=>{
                if(first) {
                    UserManager.getInstance().showTicketAd(() => {
                        Toast.make(getText("尊贵的特权玩家，已为您跳过广告啦~"))
                        resolve(true);
                    }, () => {
                        resolve(true);
                    },adPos);
                }else {
                    resolve(true);
                }  
            })
        })
    }
    throw new Error('Please implements the method! [showAd]', 'or return false in allowAds')
}
/**
 * 显示格子广告
 * @param config
 */
SnsProxy.prototype.showGridAd = function(config) {        
    console.warn('Please implements the method! [showGridAd]')
}
/**
 * 销毁格子广告
 * @param config
 */
SnsProxy.prototype.destroyGridAd = function(config) {        
    console.warn('Please implements the method! [destroyGridAd]')
}
/**
 * 隐藏格子广告
 */
SnsProxy.prototype.hideGridAd = function(adId) {        
    console.warn('Please implements the method! [hideGridAd]')
}
//模板广告，暂时只有微信有
SnsProxy.prototype.checkCustomAd = function(customAdName){
    return false
}
SnsProxy.prototype.tryShowHideCustomAdWhenPanelPop = function(isShow){
}
SnsProxy.prototype.showCustomAd = function(adConfig, customAdName){
}
SnsProxy.prototype.destroyCustomAd = function() {  
}
SnsProxy.prototype.hideCustomAd = function(){
}

SnsProxy.prototype.getSystemPlatfrom = function () {
    return META.user.serverid
}
SnsProxy.prototype.compareVersion = function (v1, v2) {
    v1 = v1.split('.')
    v2 = v2.split('.')
    var len = Math.max(v1.length, v2.length)

    while (v1.length < len) {
        v1.push('0')
    }
    while (v2.length < len) {
        v2.push('0')
    }

    for (var i = 0; i < len; i++) {
        var num1 = parseInt(v1[i])
        var num2 = parseInt(v2[i])

        if (num1 > num2) {
            return 1
        } else if (num1 < num2) {
            return -1
        }
    }

    return 0
}
SnsProxy.prototype.drawDataToImg = function (img, info = {}, callback) {
    setTimeout(() => {
        callback()
    }, 0);
}

/**
 * 获取在快捷收藏里的配置名
 */
SnsProxy.prototype.getShortcutConfigName = function() {
    return null;
}

/**
 * 是否支持快捷方式进入游戏
 */
SnsProxy.prototype.supportShortcut = function() {
    return __DEV;
}

/**
 * 是否通过快捷方式进入游戏
 */
SnsProxy.prototype.isFromShortcut = function (sceneValues) {
    // 浏览器不支持
    if (__DEV)
        return false;
    // cc.log("sns: on login finish")
    let from = getParameterByName("from")
    let via = getParameterByName("via")
    return (from === "shortcut" || via === "H5.DESKTOP")
}

SnsProxy.prototype.checkAuthorize = function (agreeCb, denyCb) {
    if (agreeCb){
        agreeCb()
    }   
}
SnsProxy.prototype.checkAuthorizeWithUserBtn = function (agreeCb, denyCb){
    if (agreeCb){
        agreeCb()
    }   
}

/**
 * 是否允许使用广告
 */
SnsProxy.prototype.allowAd = function() {
    return true;
}

/**
 * 是否允许使用分享
 */
SnsProxy.prototype.allowShare = function() {
    return true;
}

// 不同平台数据被合并的时候，选择的哪个平台
SnsProxy.prototype.getLoginChooseForMultiData = function(){
    var self = this
    if (self.loginChoose){
        return self.loginChoose;
    }else{
        return null;
    }
}
// choose  wanba=玩吧，qqlightgame=qq轻游戏
SnsProxy.prototype.setLoginChooseForMultiData = function(choose){
    var self = this
    self.loginChoose = choose;
}
SnsProxy.prototype.handleLoginDataForMultiData = function(evt, parent, reloginCb){
    var self = this;
    if (evt.data.wanba_users){
        // 有玩吧数据
        var snsuid = evt.data.wanba_users.snsuid;
        var avatar = evt.data.wanba_users.avatar;
        var nickname = evt.data.wanba_users.nickname;
        cc.log("----有玩吧数据----");
        cc.log("uid", evt.data.uid);
        if (evt.data.uid){
            // 有qq小游戏数据，选择一种后重新登录，选择保存在本地
            var chooseCb = function(choose){
                self.loginChoose = choose;
                var data = {"choose":self.loginChoose};
                if (self.loginChoose == "wanba_ts"){
                    data["snsuid"] = snsuid;
                    data["avatar"] = avatar;
                    data["nickname"] = nickname;
                }
                cc.UserDefault.getInstance().setStringForKey("MULTI_USER_DATA_CHOOSE", JSON.stringify(data));
                reloginCb();
            }
            var failCb = function(){
                reloginCb();
            }
            var choosePanel = require("clover/scene/QQLightgameChooseUserDataPanel");
            choosePanel.show(parent, evt.data, chooseCb, failCb);
        }else{
            // 没有qq小游戏数据，直接登录玩吧
            self.loginChoose = "wanba_ts";
            var data = {"choose":self.loginChoose, "snsuid":snsuid, "avatar":avatar, "nickname":nickname};
            cc.UserDefault.getInstance().setStringForKey("MULTI_USER_DATA_CHOOSE", JSON.stringify(data));
            reloginCb();
        }
        return true;
    }else if(self.loginChoose == null || self.loginChoose == ""){
        // 没有玩吧数据重新登录qq小游戏
        cc.log("self.loginChoose", self.loginChoose);
        self.loginChoose = "qq_lightgame";
        var data = {"choose":self.loginChoose};
        cc.UserDefault.getInstance().setStringForKey("MULTI_USER_DATA_CHOOSE", JSON.stringify(data));
        
        return false;
    } else {
        return false;
    }
}
SnsProxy.prototype.handleLoginDataForServerClose = function(parent, reloginCb){
    var self = this;
    let beginTime = window.first
    let endTime = window.second
    let firstNotice = window.firstNotice
    let secondNotice = window.secondNotice

    //window.first = window.second = window.firstNotice = window.secondNotice = null
    //var choosePanel = require("clover/scene/QQLightgameChooseUserDataPanel");
    //choosePanel.show(parent, evt.data, chooseCb, failCb);
    let MaintenancePanel = require("clover/scene/MaintenancePanel")
    MaintenancePanel.show(parent, beginTime, endTime, firstNotice, secondNotice, reloginCb)
}
/**
 * 是否允许开启Pvp
 */
SnsProxy.prototype.allowPvp = function() {
    return true;
}

/**
 * 是否允许开启Banner广告
 */
SnsProxy.prototype.allowBannerAd = function () {
    return false;
}

/**
 * 预加载广告
 */
SnsProxy.prototype.prepareBannerAd = function () {
    console.warn('Please implements the method! [prepareBannerAd]', 'or return false in prepareBannerAd')
    return false;
}

/**
 * 广告是否拉取完毕可以播放
 */
SnsProxy.prototype.isBannerAdReady = function(adPos) {
    console.warn('Please implements the method! [isBannerAdReady]', 'or return false in isBannerAdReady')
    return false;
}

/**
 * 显示广告
 * TODO:打点记得要调整
 */
SnsProxy.prototype.loadBannerAd = function(panel, adPos = 0, onLoadCallback, onFailCallback) {
    console.warn('Please implements the method! [showBannerAd]', 'or return false in showBannerAd')
    return false;
}

/**
 * 关闭广告
 */
SnsProxy.prototype.hideBannerAd = function (panel, adPos = 0) {
    console.warn('Please implements the method! [hideBannerAd]', 'or return false in hideBannerAd')
    return false;
}

/**
 * 是否支持互动分享模块
 */
SnsProxy.prototype.allowInteractiveInvite = function() {
    return false;
}

/**
 * 是否支持新排行互动托管功能
 */
SnsProxy.prototype.allowInteractiveRank = function() {
    return false;
}

/**
 * 是否支持跳转pc端
 */
SnsProxy.prototype.allowHandoff = function() {
    return false
}

/**
 * 显示插屏广告用
 */
SnsProxy.prototype.setNeedShowInterstitialAdName = function() {
    return false;
}

SnsProxy.prototype.getNeedShowInterstitialAdName = function() {
    return false;
}

/**
 * 获取用户所在省份
 * @param quiet 如果权限未赋予，是否不显示询问用户权限
 * @param lang 语言 目前只支持中文
 * @param callback(err: {errType: number, errInfo: 平台的回错对象}, province)
 */
SnsProxy.prototype.fetchProvince = function(quiet, callback, lang = "zh_CN") {
    throw new Error("Platform does not support fetchProvince. Please implements the method.")
}

/**
 * 是否禁止只要触发分享（不判断任何回调信息）就算成功
 */
SnsProxy.prototype.forbidShareSuccessDirectly = function() {
    return false;
}

/**
 * 检查用户是否发生了变更，如果有在这里进行同步操作
 */
SnsProxy.prototype.checkIsUserChange = function() {}

SnsProxy.prototype.getPlatformName = function () {
    return "wanba_ts"
}

/**
 * 是否不允许出现人民币购买嫌疑的内容
 * 这个值为true时，所有的【购买】文本会被替换为【兑换】
 * 在platform = wechatgame 且 os=iOS的情况下为true
 * 微信IOS平台不允许出现代币购买的文本
 */
SnsProxy.prototype.isBuyBan = function() {
   return false 
}
/**
 * 检查是否断网
 */
SnsProxy.prototype.checkNetwork = function (successCallback, failcallback) {
    if (__DEV && successCallback){
        successCallback()
        return
    }
    // failcallback()
}

SnsProxy.prototype.supportCustomerService = function () {
    return true
}

SnsProxy.prototype.getFontNameByTTF = function (url) {
    return url.replace("font/", "").replace(".ttf", "")
}
module.exports = SnsProxy